import {
  ZONE_FIELD_IDS,
  ZONE_TAB_KEYS,
} from 'features/libra/stepComponents/zoneAnalysis/zoneAnalysisApi'
import { z } from 'zod'

/**
 * Section that embeds the zone-editing surface (reference-image selection,
 * cropping, AI suggestion, drawing, and the per-zone editor cards) inside a
 * ConditionalForm step. Backed by a single array field (`zoneFieldName`,
 * default `zones`) that is progressively enriched across the workflow: the
 * Data Gathering step captures geometry/material/damage mechanisms via a
 * narrowed `visibleTabs`, while the later NII Zones step fills strategy/RBA/
 * coverage (which depend on the screening confidence).
 */
export const ZonesSectionSchema = z.object({
  id: z.string(),
  type: z.literal('zones'),
  title: z.string().optional(),
  /** The ticket field storing the zone array. Defaults to `zones`. */
  zoneFieldName: z.string().default(ZONE_FIELD_IDS.ZONES),
  /**
   * Optional subset and display order of zone editor tabs. When omitted, the
   * editor renders every available tab in its default order.
   */
  visibleTabs: z.array(z.enum(ZONE_TAB_KEYS)).optional(),
  /**
   * Optional agent config block driving the AI zone-suggestion strategy. Opaque
   * to Forecast — read by gong-agent-service via the workflow config. The
   * embedded "Pre-fill with AI" button keys off this section's `id`.
   */
  agent: z.record(z.string(), z.unknown()).optional(),
  /**
   * When present, the AI suggest action is only shown to users holding at least
   * one of these permissions, along with Gecko Internal (by default).
   */
  agentPermissions: z.array(z.string()).optional(),
})

export type ZonesSection = z.infer<typeof ZonesSectionSchema>
